// @flow
export { default as theme } from '@rover/design-system/style-dictionary/build/es6/theme';

export { default as margin } from './margin';
export { default as textAlign } from './textAlign';
export { default as textColor } from './textColor';
export { default as fontWeight } from './fontWeight';
export { default as textTransform } from './textTransform';
export { default as textDecoration } from './textDecoration';

export type { MarginProps } from './margin';
export type { TextAlignProps } from './textAlign';
export type { TextColorProps } from './textColor';
export type { FontWeightProps } from './fontWeight';
export type { TextTransformProps } from './textTransform';
export type { TextDecorationProps } from './textDecoration';



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/index.js